import { jsxs as u, jsx as s } from "react/jsx-runtime";
import { FormInputSearch as d, FormSelectMultiple as c, PrimaryButton as x } from "@systemeio/ui";
import { useTranslation as n } from "../../../i18n.mjs";
import { FileSourceEnum as o } from "../../../libs/types/dist/index5.mjs";
import { FileTypeEnum as N } from "../../../libs/types/dist/index6.mjs";
import { FileSourceEnumLocoKeys as _ } from "../../../enums/file-source-enum.mjs";
import { FileTypeEnumLocoKeys as y } from "../../../enums/file-type-enum.mjs";
function P({
  isFetching: a,
  values: r,
  disabled: m,
  disabledFileSourceSelect: i,
  disabledFileTypeSelect: p,
  onChange: l,
  onSubmit: f
}) {
  const { t } = n();
  return /* @__PURE__ */ u(
    "form",
    {
      onSubmit: (e) => {
        e.preventDefault(), e.stopPropagation(), f();
      },
      className: "flex flex-col gap-2 sm:grid sm:grid-cols-2 lg:flex lg:flex-row lg:items-end lg:flex-wrap",
      children: [
        /* @__PURE__ */ s(
          d,
          {
            disabled: a || m,
            label: t("file_manager.file_selector.search_file"),
            placeholder: t("file_manager.search"),
            value: r.name,
            onClear: () => l == null ? void 0 : l({ ...r, name: "" }),
            onChange: (e) => l == null ? void 0 : l({ ...r, name: e.target.value }),
            showSearchIcon: !0,
            className: "lg:flex-2",
            labelClassName: "text-text-primary text-lg font-bold",
            searchIconClassName: "left-3 top-[31px]",
            closeIconClassName: "top-[31px]",
            inputClassName: "!pl-[40px] pr-4"
          }
        ),
        /* @__PURE__ */ s(
          c,
          {
            disabled: a || m || i,
            placeholder: t("file_manager.select_source"),
            value: r.source,
            data: Object.values(o).filter((e) => e !== o.BlockPreview && e !== o.Community).map((e) => ({
              id: e,
              caption: t(_[e])
            })),
            onChange: (e) => l == null ? void 0 : l({ ...r, source: e }),
            containerClassName: "self-auto sm:self-end"
          }
        ),
        /* @__PURE__ */ s(
          c,
          {
            disabled: a || m || p,
            placeholder: t("file_manager.select_type"),
            value: r.type,
            data: Object.values(N).map((e) => ({
              id: e,
              caption: t(y[e])
            })),
            onChange: (e) => l == null ? void 0 : l({ ...r, type: e }),
            containerClassName: "self-auto sm:self-end"
          }
        ),
        /* @__PURE__ */ s(
          x,
          {
            type: "submit",
            isFetching: a,
            disabled: m,
            className: "min-w-14",
            children: t("file_manager.search")
          }
        )
      ]
    }
  );
}
export {
  P as FileSearch
};
